(() => {
  if (!('IntersectionObserver' in window)) {
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const unique = (items) => Array.from(new Set(items.filter(Boolean)));
  const armedItems = [];

  const ignoredSelector = [
    'header',
    '.header',
    '.header-section',
    '.product-card',
    '.collection-card',
    '.predictive-search-results__card',
    '.cart-drawer',
    'dialog',
    '[data-furriko-motion-ignore]',
  ].join(',');

  const mediaSelector = [
    'image-block',
    '.image-block',
    '.media-block',
    '[class*="media-block"]',
    '.hero__media-wrapper',
    '.background-image-container',
    'picture',
  ].join(',');

  const textSelector = [
    '.text-block',
    '[class*="text-block"]',
    '.rich-text',
    '[class*="rich-text"]',
  ].join(',');

  const arm = (element, className = 'furriko-motion-up', delay = 0) => {
    if (!element || element.dataset.furrikoMotionArmed || element.closest(ignoredSelector)) {
      return null;
    }

    element.dataset.furrikoMotionArmed = 'true';
    element.classList.add('furriko-motion-item', className);
    element.style.setProperty('--furriko-motion-delay', `${delay}ms`);
    armedItems.push(element);

    return element;
  };

  const revealPageSections = () => {
    const sections = Array.from(document.querySelectorAll('main .shopify-section, main section'));

    sections.forEach((section) => {
      const textItems = unique(
        Array.from(section.querySelectorAll(textSelector)).map((item) => item.closest('.group-block') || item)
      );

      const mediaItems = unique(
        Array.from(section.querySelectorAll(mediaSelector)).map((item) => item.closest(mediaSelector) || item)
      );

      unique([...textItems, ...mediaItems])
        .filter((item) => item.offsetParent !== null)
        .sort((a, b) => {
          const topDifference = a.getBoundingClientRect().top - b.getBoundingClientRect().top;

          if (Math.abs(topDifference) > 12) {
            return topDifference;
          }

          return a.getBoundingClientRect().left - b.getBoundingClientRect().left;
        })
        .forEach((item, index) => {
          const isMedia = item.matches(mediaSelector) || item.querySelector(mediaSelector);
          arm(item, isMedia ? 'furriko-motion-media' : 'furriko-motion-up', Math.min(index * 90, 360));
        });
    });
  };

  revealPageSections();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.08,
    }
  );

  window.requestAnimationFrame(() => {
    armedItems.forEach((item) => observer.observe(item));
  });

  document.documentElement.setAttribute('data-furriko-motion-count', `${armedItems.length}`);
  document.documentElement.setAttribute('data-furriko-motion-version', 'global-up-scroll');
})();

(() => {
  const anchorTargets = {
    '#learn-more-fountain': "[id$='__section_hW6xre']",
  };

  const getHeaderOffset = () => {
    const header = document.querySelector('#header-group, #header-component, .header-section, .shopify-section-group-header-group');

    return header ? header.getBoundingClientRect().height : 0;
  };

  const scrollToMappedAnchor = () => {
    const targetSelector = anchorTargets[window.location.hash];

    if (!targetSelector) {
      return;
    }

    const target = document.querySelector(targetSelector);

    if (!target) {
      return;
    }

    const targetTop = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - 16;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: 'smooth',
    });
  };

  window.addEventListener('hashchange', scrollToMappedAnchor);
  window.addEventListener('load', () => {
    window.setTimeout(scrollToMappedAnchor, 80);
    window.setTimeout(scrollToMappedAnchor, 500);
  });
})();
